import styles from "./WindowSkeleton.module.css";

/**
 * WindowSkeleton — placeholder dla pojedynczego okna podczas streaming'u
 * content'u. Renderowany jako Suspense fallback w `WindowAreaView` per
 * `id_window` — gdy `fetchWindowContent` promise jeszcze nie resolved'a,
 * React pokazuje tę zaślepkę.
 *
 * **Geometry (od 2026-05-18):** minimalistyczny shimmer dopasowany do rodzica
 * — `width: 100%`, `min-height: 24px`, `max-height: 100%`. Bez własnej karty
 * (`WindowContainer` już ją renderuje przez `KDefault`/`KGreyTitle`/...).
 *
 * Powód: poprzedni 4-paskowy skeleton miał wysokość ~120px co dla małych
 * okien (pill button typu `w_language_versions` ~40px) powodowało CLS — po
 * resolve'ie promise'a area kurczyła się o ~80px i strona "skakała".
 *
 * Spójność wizualna z `.skeleton-base` z `globals.css` (theme-aware kolory).
 */
export function WindowSkeleton() {
  return (
    <div className={styles.root} aria-busy="true" aria-label="Wczytywanie okna">
      <div className={`skeleton-base ${styles.bar}`} />
    </div>
  );
}
